<template>
	<div style="overflow-x: hidden !important">
		<div style="display: flex; flex-direction: column">
			<div v-show="false" style="height: 1200px; overflow: scroll">
				<fill-layout
					v-if="processed_doc"
					@loaded="
						data => {
							pushBoi(data)
						}
					"
					:exportHTML="true"
					:key="processed_doc"
					:doc_id="processed_doc"
				></fill-layout>
			</div>

			<div class="main" :style="{ width: widthscreen }">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ pageTitle }}</h1>
						<h5>{{ computedProjNumber }}</h5>
					</div>

					<div>
						<div class="header_actions" style="margin-top: 20px">
							<div class="header_actions-container">
								<el-alert
									v-if="!is_sub_active && isSuperAdmin && is_sub_active !== undefined"
									:title="$t('expired-subscription-for-school')"
									type="warning"
									effect="dark"
									:closable="false"
									show-icon
								>
								</el-alert>
								<el-button
									v-if="(isFolder || isProject) && documents.length != 0"
									type="success"
									@click="StartDownloadAll()"
								>
									{{ $t("download-all").toUpperCase() }}
								</el-button>

								<el-button
									v-if="$route.params.project_id"
									type="success"
									@click="projectVariablesPopup = true"
								>
									{{ $t("data").toUpperCase() }}
								</el-button>

								<el-input
									style="width: auto"
									:placeholder="$t($route.params.project_id ? 'documents-search' : 'projects-search')"
									v-model="search"
									@keyup.enter.native="reload"
								>
									<el-button slot="append" icon="el-icon-search" @click="reload" />
								</el-input>
							</div>
						</div>
					</div>
				</div>

				<div class="documents infinite-list-wrapper" style="overflow: auto">
					<div
						class="documents_container list"
						v-infinite-scroll="scrollLoad"
						:infinite-scroll-disabled="scrollDisabled"
						infinite-scroll-distance="50"
						style="margin-bottom: 100px"
					>
						<div
							v-for="document in documents"
							:key="`${document.id}_doc`"
							@click="navigateToDocument(document)"
							class="documents_wrapper list-item"
						>
							<div class="documents_upper">
								<div class="documents_thumb">
									<div style="display: flex; height: 100%">
										<md-icon class="md-size-5x" style="color: #1a73e8">description</md-icon>
									</div>
								</div>
							</div>
							<div class="documents_details">
								<div class="documents_details-infos">
									<div v-if="document.flowchart" class="documents_details-title">
										{{ document.flowchart.title }}
									</div>
								</div>
								<div class="documents_details-infos3">
									<el-tag
										v-if="document.status === 'confirmed'"
										type="success"
										style="margin-left: 3px; margin-bottom: 3px"
									>
										{{ $t("saved") | capitalize }}
									</el-tag>
									<el-tag v-else type="warning" style="margin-left: 3px; margin-bottom: 3px">
										{{ $t("draft") | capitalize }}
									</el-tag>
									<el-tag
										v-if="
											document.flowchart &&
											document.flowchart.status !== 'published' &&
											!document.publishedFlowchart
										"
										type="warning"
										style="margin-left: 3px; margin-bottom: 3px"
									>
										{{ $t("warning") | capitalize }}
									</el-tag>
									<el-tag
										v-if="!document.flowchart"
										type="danger"
										style="margin-left: 3px; margin-bottom: 3px"
									>
										{{ $t("warning") | capitalize }}
									</el-tag>
								</div>
								<div class="documents_details-infos3">
									<span>
										{{ $t("last-edit") | capitalize }}: {{ formatDate(document.updated_at) }}
									</span>
								</div>
								<div class="documents_details-infos2">
									<div>
										<md-button @click="e => shiftDocument(e, document)" class="md-icon-button">
											<md-icon>arrow_upward</md-icon>
											<md-tooltip md-direction="bottom">
												{{ $t("shift-document") }}
											</md-tooltip>
										</md-button>
									</div>
									<div>
										<md-button @click="e => cloneDocument(e, document)" class="md-icon-button">
											<md-icon>file_copy</md-icon>
											<md-tooltip md-direction="bottom">
												{{ $t("clone") }}
											</md-tooltip>
										</md-button>
									</div>
									<div>
										<md-button @click="e => deleteDocument(e, document)" class="md-icon-button">
											<md-icon>delete</md-icon>
											<md-tooltip md-direction="bottom">
												{{ $t("delete") }}
											</md-tooltip>
										</md-button>
									</div>
								</div>
							</div>
						</div>

						<div
							v-for="project in projects"
							:key="`${project.id}_proj`"
							@click="goto(folderLink(project.id))"
							class="documents_wrapper list-item"
						>
							<div class="documents_upper">
								<div class="documents_thumb">
									<div style="display: flex; height: 100%">
										<md-icon class="md-size-5x" style="color: #fbbc04">folder</md-icon>
									</div>
								</div>
							</div>
							<div class="documents_details">
								<div class="documents_details-infos">
									<div class="documents_details-title">
										{{ project.name }}
									</div>
								</div>
								<div class="documents_details-infos2">
									<div v-if="project.project_id">
										<md-button @click="e => cloneProcedure(e, project)" class="md-icon-button">
											<md-icon>file_copy</md-icon>
											<md-tooltip md-direction="bottom">
												{{ $t("clone") }}
											</md-tooltip>
										</md-button>
									</div>
									<div>
										<md-button @click="e => deleteProject(e, project)" class="md-icon-button">
											<md-icon>delete</md-icon>
											<md-tooltip md-direction="bottom">
												{{ $t("delete") }}
											</md-tooltip>
										</md-button>
									</div>
									<div>
										<md-button @click="e => renameProject(e, project)" class="md-icon-button">
											<md-icon> drive_file_rename_outline</md-icon>
											<md-tooltip md-direction="bottom">
												{{ $t("rename") }}
											</md-tooltip>
										</md-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="float-center">
					<div class="float-content-spinner" v-if="scrollLoading">
						<i class="el-icon-loading" />
					</div>
					<div
						class="float-content"
						v-bind:class="{
							visible: scrollNoMoreSnackbar,
							hidden: !scrollNoMoreSnackbar
						}"
					>
						<div class="float-text">
							{{ $t("no-more-projects") }}
						</div>
					</div>
				</div>

				<floating-button @add="addNew" v-if="subscription || isSuperAdmin"></floating-button>

				<add-edit-project :show="addEditPopup" :project="selectedProject" @close="p => afterAddEdit(p)" />
				<add-folder :show="folderPopup" @close="p => addFolder(p)" :project_id="current_folder" />
				<add-document
					:show="documentPopup"
					@close="documents => addDocuments(documents)"
					:project_id="current_folder"
				/>
				<project-variables
					v-if="$route.params.project_id"
					:show="projectVariablesPopup"
					@close="projectVariablesPopup = false"
				/>
				<shift-document
					:show="shiftDocumentPopup"
					:document="selectedDocument"
					@close="shiftDocumentPopup = false"
				/>
				<clone-document
					:show="cloneDocumentPopup"
					:document="selectedDocument"
					@close="cloneDocumentPopup = false"
					@reload="reload"
				/>
				<clone-procedure
					:show="cloneProcedurePopup"
					:procedure="selectedProcedure"
					@close="cloneProcedurePopup = false"
					@reload="reload"
				/>

				<delete-confirm-modal
					:show="deleteProjectPopup"
					:title="$t('project-delete')"
					:content="$t('project-delete2')"
					@close="afterDeleteProject"
				/>

				<delete-confirm-modal
					:show="deleteDocumentPopup"
					:title="$t('delete-document')"
					:content="$t('document-delete2')"
					@close="afterDeleteDocument"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { goto, filters, formatDate } from "@/utils/utils"
import AddEditProject from "@/modules/projects/component/modals/add-edit-project"
import AddFolder from "@/modules/projects/component/modals/add-folder"
import AddDocument from "@/modules/projects/component/modals/add-document"
import ProjectVariables from "@/modules/projects/component/modals/project-variables"
import ShiftDocument from "@/modules/projects/component/modals/shift-document"
import CloneDocument from "@/modules/projects/component/modals/clone-document"
import CloneProcedure from "@/modules/projects/component/modals/clone-procedure"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"
import FloatingButton from "@/modules/projects/component/floating-button"
import { mapMutations, mapActions, mapGetters } from "vuex"
import FillLayout from "@/modules/documents/fill-layout"

export default {
	name: "MyProjects",

	mixins: [filters],

	components: {
		FillLayout,
		DeleteConfirmModal,
		AddEditProject,
		FloatingButton,
		AddFolder,
		AddDocument,
		ProjectVariables,
		ShiftDocument,
		CloneDocument,
		CloneProcedure
	},

	data() {
		return {
			isFolder: false,
			isProject: false,
			processed_doc: undefined,
			wait_for_html: true,
			returned_html: [],
			associazioni: [],

			projects: [],
			documents: [],
			projectNumber: undefined,
			documentNumber: undefined,
			search: "",
			selectedProject: undefined,
			selectedProcedure: {},
			selectedDocument: {},
			addEditPopup: false,
			folderPopup: false,
			documentPopup: false,
			projectVariablesPopup: false,
			shiftDocumentPopup: false,
			cloneDocumentPopup: false,
			cloneProcedurePopup: false,
			deleteProjectPopup: false,
			deleteDocumentPopup: false,
			current_folder: undefined,

			scrollLoading_d: false,
			scrollNoMoreSnackbar_d: false,
			scrollEnded_d: false,
			scrollLoading_p: false,
			scrollNoMoreSnackbar_p: false,
			scrollEnded_p: false,
			tilesNumber: 1,
			rowsToLoad: 4,
			loadedPages: 0,

			widthscreen: window.innerWidth,
			pageTitle: "",
			is_sub_active: undefined,

			downloading_index: 0,
			try_msec: 23000 //(fare sempre quello di fill-layout + 3000) se si modifica questo, modificare anche dentro fill-layout
		}
	},
	created() {
		this.isFolder = this.$route.params.folder_id !== undefined ? true : false
		this.isProject = this.$route.params.project_id !== undefined ? true : false

		this.current_folder = this.$route.params.folder_id
			? this.$route.params.folder_id
			: this.$route.params.project_id
		this.tilesNumber = Math.floor(this.widthscreen / 340)
		this.getDocuments()
		this.getProjects()
		this.getPageTitle()
	},
	mounted() {
		this.setOwners() // deve stare nel mounted perché viene chiamato dopo il beforeDestroy di fill-layout
	},
	watch: {
		async associazioni() {
			if (this.associazioni.length === this.documents.length && this.associazioni.length != 0) {
				await this.downloadAll()
			}
		},
		scrollNoMoreSnackbar() {
			if (this.scrollNoMoreSnackbar) {
				setTimeout(() => {
					this.scrollNoMoreSnackbar_d = this.scrollNoMoreSnackbar_p = false
				}, 3000)
			}
		},
		$route() {
			this.isFolder = this.$route.params.folder_id !== undefined ? true : false
			this.isProject = this.$route.params.project_id !== undefined ? true : false
			this.search = ""
		},
		"$route.params.folder_id"(newValue) {
			this.isFolder = this.$route.params.folder_id !== undefined ? true : false
			this.isProject = this.$route.params.project_id !== undefined ? true : false
			if (newValue || this.$route.params.project_id) {
				this.reload()
				this.setOwners()
			}
		},
		"$route.params.project_id"(newValue) {
			this.isFolder = this.$route.params.folder_id !== undefined ? true : false
			this.isProject = this.$route.params.project_id !== undefined ? true : false
			this.reload()
			newValue && this.setOwners()
		}
	},
	computed: {
		...mapGetters({
			user: "user/user",
			isSuperAdmin: "user/isSuperAdmin",
			subscription: "organization/active_subscription",
			canCreateDocuments: "organization/canCreateDocuments",
			canCreateProcedures: "organization/canCreateProcedures"
		}),
		computedProjNumber: function () {
			if (this.$route.params.project_id == undefined && this.$route.params.folder_id == undefined)
				return this.$t("projects-counter").replace("%NUMBER%", this.projectNumber)
			else if (this.$route.params.project_id != undefined && this.$route.params.folder_id == undefined)
				return this.$t("documents-folders-counter")
					.replace("%DOCSNUMBER%", this.documentNumber)
					.replace("%NUMBER%", this.projectNumber)
			else if (this.$route.params.project_id != undefined && this.$route.params.folder_id != undefined)
				return this.$t("documents-counter").replace("%DOCSNUMBER%", this.documentNumber)
		},
		scrollLoading() {
			return this.scrollLoading_d || this.scrollLoading_p
		},
		scrollNoMoreSnackbar() {
			return this.scrollNoMoreSnackbar_d && this.scrollNoMoreSnackbar_p
		},
		scrollEnded() {
			return this.scrollEnded_d && this.scrollEnded_p
		},
		scrollDisabled() {
			return this.scrollLoading || this.scrollEnded
		}
	},
	methods: {
		goto,
		formatDate,
		...mapMutations({
			setCompilationOwners: "compilation/SET_OWNERS"
		}),
		...mapActions({
			setCreatedDocuments: "organization/setCreatedDocuments",
			setCreatedProcedures: "organization/setCreatedProcedures"
		}),
		folderLink(id) {
			let base = this.$route.params.school_id
				? `/projects/school-projects/${this.$route.params.school_id}/`
				: "/projects/my-projects/"
			if (this.current_folder) return base + this.current_folder + "/" + id
			else return base + id
		},
		fillRoute(document_id) {
			let base = this.$route.params.school_id
				? `/projects/school-projects/${this.$route.params.school_id}`
				: "/projects/my-projects"
			if (this.$route.params.folder_id)
				return `${base}/${this.$route.params.project_id}/${this.$route.params.folder_id}/fill/${document_id}`
			else return `${base}/${this.$route.params.project_id}/fill/${document_id}`
		},
		getPageTitle() {
			this.pageTitle = this.$t("my-projects")
			if (this.current_folder) {
				axios(`${process.env.VUE_APP_API_URL}/api/projects/${this.current_folder}`, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
					.then(({ data }) => (this.pageTitle = data.name))
					.catch(() => {})
			} else if (this.$route.params.school_id) {
				axios
					.get(process.env.VUE_APP_API_URL + "/api/organizations/" + this.$route.params.school_id, {
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						}
					})
					.then(res => {
						this.pageTitle = this.$t("projects") + " " + res.data.name.String
						this.is_sub_active = res.data.is_active
					})
					.catch(err => {})
			}
		},
		getDocuments() {
			if (this.current_folder) {
				const payload = {
					pagination: {
						offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
						size: this.rowsToLoad * this.tilesNumber
					},
					search: this.search.toLowerCase(),
					project_id: this.current_folder
				}

				if (!this.scrollEnded_d) {
					this.scrollLoading_d = true
					axios
						.post(process.env.VUE_APP_API_URL + "/api/documents/getByProj", payload, {
							headers: {
								Authorization: `Bearer ${localStorage.getItem("JWT")}`
							}
						})
						.then(res => {
							this.documentNumber = res.data.count
							this.documents.push(...res.data.items)
							if (res.data.items.length == 0) {
								this.scrollNoMoreSnackbar_d = true
								this.scrollEnded_d = true
							}
							this.scrollLoading_d = false
						})
						.catch(() => {
							this.scrollLoading_d = false
							this.scrollNoMoreSnackbar_d = true
							this.scrollEnded_d = true
						})
				} else {
					this.scrollNoMoreSnackbar_d = true
				}
			} else {
				this.scrollNoMoreSnackbar_d = true
			}
		},
		getProjects() {
			const payload = {
				pagination: {
					offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
					size: this.rowsToLoad * this.tilesNumber
				},
				search: this.search.toLowerCase(),
				organization_id: this.$route.params.school_id,
				project_id: this.current_folder
			}
			if (!this.scrollEnded_p) {
				this.scrollLoading_p = true

				axios
					.post(process.env.VUE_APP_API_URL + "/api/projects/get", payload, {
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						}
					})
					.then(({ data }) => {
						this.projectNumber = data.total
						this.projects = this.projects.concat(data.items)
						this.scrollLoading_p = false
						if (data.items.length === 0) {
							this.scrollNoMoreSnackbar_p = true
							this.scrollEnded_p = true
						}
					})
					.catch(() => {
						this.scrollLoading_p = false
						this.scrollNoMoreSnackbar_p = true
						this.scrollEnded_p = true
					})
			} else this.scrollNoMoreSnackbar_p = true
		},
		scrollLoad() {
			this.loadedPages++
			this.getDocuments()
			this.getProjects()
		},
		reload() {
			this.current_folder = this.$route.params.folder_id
				? this.$route.params.folder_id
				: this.$route.params.project_id
			this.loadedPages = 0
			this.scrollEnded_p = this.scrollEnded_d = false
			this.scrollLoading_p = this.scrollLoading_d = false
			this.scrollNoMoreSnackbar_p = this.scrollNoMoreSnackbar_d = false
			this.projects = []
			this.documents = []
			this.getDocuments()
			this.getProjects()
			this.getPageTitle()
		},
		shiftDocument(event, document) {
			event.stopPropagation()
			event.preventDefault()
			this.selectedDocument = { ...document, title: document.flowchart ? document.flowchart.title : "" }
			this.shiftDocumentPopup = true
		},
		cloneDocument(event, document) {
			event.stopPropagation()
			event.preventDefault()
			if (!this.canCreateDocuments) return this.$alert(this.$t("max-documents-created"), this.$t("warning"))
			this.selectedDocument = { ...document, title: document.flowchart ? document.flowchart.title : "" }
			this.cloneDocumentPopup = true
		},
		cloneProcedure(event, procedure) {
			event.stopPropagation()
			event.preventDefault()
			this.selectedProcedure = procedure
			this.cloneProcedurePopup = true
		},
		renameProject(e, project) {
			e.stopPropagation()
			e.preventDefault()
			this.selectedProject = project
			this.addEditPopup = true
		},
		deleteDocument(event, document) {
			event.stopPropagation()
			event.preventDefault()
			this.selectedDocument = document
			this.deleteDocumentPopup = true
		},
		deleteProject(e, project) {
			e.stopPropagation()
			e.preventDefault()
			this.selectedProject = project
			this.deleteProjectPopup = true
		},
		addFolder(p) {
			if (p) {
				this.reload()
			}
			this.folderPopup = false
		},
		addDocuments(documents) {
			if (documents) {
				if (!this.documents) this.documents = []
				this.documents = this.documents.concat(documents)
			}
			this.documentPopup = false
		},
		afterAddEdit(project) {
			if (project) {
				if (this.selectedProject) {
					this.selectedProject.name = project.name
				} else {
					this.reload()
				}
			}
			this.selectedProject = undefined
			this.addEditPopup = false
		},
		afterDeleteProject(doDelete) {
			if (doDelete) {
				axios
					.delete(`${process.env.VUE_APP_API_URL}/api/projects/${this.selectedProject.id}`, {
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						}
					})
					.then(() => {
						const index = this.projects.findIndex(project => project.id === this.selectedProject.id)
						if (index != -1) {
							this.projectNumber--
							this.projects.splice(index, 1)
						}

						this.$notification("success", this.$t("deleted-successfully"), "")

						this.setCreatedDocuments()
						this.setCreatedProcedures()
					})
					.catch(err => this.$processError(this.$t("delete-error"), err.response.data.Message))
			}
			this.deleteProjectPopup = false
		},
		afterDeleteDocument(doDelete) {
			if (!doDelete) return (this.deleteDocumentPopup = false)

			const { id: documentId } = this.selectedDocument

			axios
				.delete(`${process.env.VUE_APP_API_URL}/api/documents/delete/${documentId}`, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
				.then(() => {
					this.documents = this.documents.filter(({ id }) => id !== documentId)
					this.$notification("success", this.$t("deleted-successfully"), "")
					this.setCreatedDocuments()
				})
				.catch(
					({
						response: {
							data: { Message: message }
						}
					}) => this.$processError(this.$t("delete-error"), message)
				)
				.finally(() => (this.deleteDocumentPopup = false))
		},
		async addNew(what) {
			switch (what) {
				case "project":
					this.selectedProject = undefined
					this.addEditPopup = true
					break

				case "folder":
					if (!this.canCreateProcedures)
						return this.$alert(this.$t("max-procedures-created"), this.$t("warning"))
					this.folderPopup = true
					break

				case "document":
					if (!this.canCreateDocuments)
						return this.$alert(this.$t("max-documents-created"), this.$t("warning"))
					this.documentPopup = true
					break
			}
		},
		setOwners() {
			const owners = {}
			owners[this.$route.params.school_id || this.user.organization.id] = [-1, 0]
			if (this.$route.params.folder_id) {
				owners[this.$route.params.project_id] = [1]
				owners[this.$route.params.folder_id] = [2]
			} else owners[this.$route.params.folder_id || this.$route.params.project_id] = [1, 2]

			this.setCompilationOwners(owners)
		},
		navigateToDocument(document) {
			let { id: documentId, flowchart, publishedFlowchart } = document
			flowchart = flowchart || {}

			let translationKey = false

			if (Object.keys(flowchart).length && flowchart.status !== "published" && !publishedFlowchart)
				translationKey = "warning-no-published-flowcharts"
			else if (!Object.keys(flowchart).length && !publishedFlowchart) translationKey = "warning-deleted-flowchart"

			if (translationKey) this.$alert(this.$t(translationKey), this.$t("warning"))
			else this.goto(this.fillRoute(documentId))
		},
		...mapMutations({
			openLoad: "modules/OPEN_LOADING",
			changeLoadTime: "modules/CHANGE_LOADING",
			closeLoad: "modules/CLOSE_LOADING"
		}),
		StartDownloadAll() {
			this.openLoad({ msec: this.try_msec * this.documents.length, lock: true })
			// this.$message({ message: this.$t("dont-leave"), duration: 0, showClose: true })

			this.downloading_index = 0

			this.processed_doc = this.documents[this.downloading_index].id
		},
		DownloadNext() {
			this.downloading_index++

			if (this.downloading_index < this.documents.length) {
				this.changeLoadTime(this.try_msec * (this.documents.length - this.downloading_index))
				this.processed_doc = this.documents[this.downloading_index].id
			}
		},
		pushBoi(element) {
			this.DownloadNext()

			this.returned_html.push(element)
			var h = element
			var b = '<p style="margin-left: 1cm; margin-right: 1cm; background: transparent">' + h.content + "</p>"
			b = b.replaceAll("<div", "<span")
			b = b.replaceAll('start="1"', "")
			b = b.replaceAll("keyboard_double_arrow_left", "")
			b = b.replaceAll("keyboard_double_arrow_right", "")

			var blob = new Blob([b], { type: "text/html" })
			var form_data = new FormData()
			form_data.append("blob", blob)
			form_data.append("file_name", h.title)

			axios
				.post(process.env.VUE_APP_API_URL + "/api/docx/convert", form_data, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					this.associazioni.push({
						id: res.data.name,
						titolo: h.title.replaceAll("/", "-"),
						unique: h.unique
					})
				})
				.catch(err => console.error(err))
		},

		async downloadAll() {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/docx/export_batch",
					{ title: this.pageTitle.replaceAll("/", "-"), array: this.associazioni },
					{
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						},
						responseType: "arraybuffer"
					}
				)
				.then(res => {
					this.associazioni = []
					this.processed_doc = undefined
					const url = window.URL.createObjectURL(new Blob([res.data]))
					const link = document.createElement("a")
					link.href = url
					link.setAttribute("download", `${this.pageTitle}.zip`)
					link.click()
					this.closeLoad(true)
				})
				.catch(err => {
					console.error(err)
					this.closeLoad(true)
					this.$notification("error", this.$t("download-zip-error"), "", 0)
				})
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";

.float-content-spinner {
	width: 50px;
	height: 50px;
	font-size: 40px;
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
	padding-top: 5px;
	transform: translate(-25px);
}

.float-content {
	width: 300px;
	height: 30px;
	transform: translate(-150px);
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
}

.visible {
	visibility: visible;
	opacity: 1;
}

.hidden {
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 1s, opacity 1s linear;
}

.float-text {
	padding-top: 5px;
}
</style>
